module.exports = __webpack_public_path__ + "img/event.a09fe51.svg";